/*
 * The included printed copy's delivery, final check and receipt (accepted R77 print order). Scoped
 * to the journey, so it reads the same inside the print review and the guided book steps.
 */
.print-journey {
  color: var(--lc-text);
  min-width: 0;
}
.print-journey h2,
.print-journey h3 {
  font-family: var(--lc-font-display);
  font-weight: 500;
  line-height: 1.15;
  color: var(--lc-text-strong);
  text-wrap: balance;
}
.print-journey h2 {
  font-size: 1.8rem;
  margin: 0 0 0.85rem;
}
.print-journey h2:focus {
  outline: none;
}
.print-journey h3 {
  font-size: 1.35rem;
  margin: 0 0 0.6rem;
}
.print-journey p {
  line-height: 1.65;
  max-width: 65ch;
}
.print-journey .print-address > p {
  margin: 0 0 1.5rem;
}
.print-journey .print-field-grid {
  display: grid;
  gap: 1.1rem;
  border: 0;
  margin: 0;
  padding: 0;
  min-width: 0;
}
.print-journey .print-city-row {
  display: grid;
  grid-template-columns: 1.45fr 0.8fr 1fr;
  gap: 0.8rem;
  align-items: start;
}
.print-journey .lc-field {
  margin: 0;
  min-width: 0;
}
.print-journey .lc-field input {
  width: 100%;
  min-height: 46px;
}
.print-journey .lc-field__description {
  font-size: 0.8125rem;
}
.print-journey .print-city-row .lc-field {
  display: flex;
  flex-direction: column;
}
.print-journey .print-city-row .lc-field__label-row {
  order: 0;
}
.print-journey .print-city-row .lc-input {
  order: 1;
}
.print-journey .print-city-row .lc-field__description {
  order: 2;
  margin: 0.3rem 0 0;
}
.print-journey .print-actions {
  display: flex;
  align-items: center;
  gap: 0.75rem 1rem;
  flex-wrap: wrap;
  margin-top: 1.75rem;
}
.print-journey .print-actions .lc-action {
  white-space: normal;
  min-height: 48px;
}
.print-journey .print-actions .lc-action svg {
  margin-left: 0.5rem;
  vertical-align: middle;
}
.print-journey .print-actions > a:not(.lc-action) {
  display: inline-flex;
  align-items: center;
  min-height: 44px;
}
.print-journey a.lc-action--primary {
  color: var(--lc-surface);
}
.print-journey .print-note {
  color: var(--lc-text-muted);
  font-size: 0.875rem;
  line-height: 1.6;
  margin: 1rem 0 0;
}
.print-journey .print-delivery-summary {
  display: grid;
  grid-template-columns: 24px 1fr auto;
  gap: 0.75rem;
  align-items: start;
  padding: 1.25rem 0;
  border-top: 1px solid var(--lc-control-border);
  border-bottom: 1px solid var(--lc-control-border);
  margin: 1.5rem 0;
}
.print-journey .print-delivery-summary > svg {
  color: var(--lc-success);
  margin-top: 0.15rem;
}
.print-journey .print-delivery-summary h3 {
  font: 600 1rem/1.4 var(--lc-font-ui);
  margin: 0 0 0.5rem;
}
.print-journey .print-delivery-summary address {
  font-style: normal;
  line-height: 1.6;
  overflow-wrap: anywhere;
}
.print-journey .print-delivery-summary .lc-action {
  margin-top: -0.5rem;
}
.print-journey .print-final-facts {
  margin: 1.5rem 0;
}
.print-journey .print-final-facts > div {
  display: grid;
  grid-template-columns: 1fr 1.65fr;
  gap: 1rem;
  padding: 0.75rem 0;
  border-bottom: 1px solid var(--lc-control-border);
}
.print-journey .print-final-facts > div:first-child {
  border-top: 1px solid var(--lc-control-border);
}
.print-journey .print-final-facts dt {
  font-size: 0.875rem;
  color: var(--lc-text-muted);
}
.print-journey .print-final-facts dd {
  margin: 0;
  line-height: 1.5;
  font-variant-numeric: tabular-nums;
  overflow-wrap: anywhere;
}
.print-journey .print-error {
  margin-top: 1.25rem;
  color: var(--lc-danger);
  font-size: 0.9375rem;
}
.print-journey .print-error p {
  margin: 0.5rem 0;
}
.print-journey .print-error a {
  display: inline-flex;
  min-height: 44px;
  align-items: center;
  margin-right: 1rem;
}
.print-journey .print-reference {
  font-size: 0.9375rem;
  color: var(--lc-text-muted);
}
.print-journey .print-reference strong {
  font-variant-numeric: tabular-nums;
  font-weight: 600;
  color: var(--lc-text);
}
.print-journey .print-next {
  margin-top: 1.75rem;
  padding-top: 1.5rem;
  border-top: 1px solid var(--lc-control-border);
}
.print-journey .print-next p {
  font-size: 0.9375rem;
}
.print-journey .print-uncertain > svg {
  color: var(--lc-link);
  margin-bottom: 0.75rem;
}
@media (max-width: 850px) {
  .print-journey .print-city-row {
    grid-template-columns: 1fr 1fr;
  }
  .print-journey .print-city-row > .lc-field:first-child {
    grid-column: 1/-1;
  }
}
@media (max-width: 700px) {
  .print-journey h2 {
    font-size: 1.6rem;
  }
  .print-journey .print-actions {
    gap: 0.5rem;
    align-items: stretch;
  }
  .print-journey .print-actions > .lc-action {
    flex: 1 1 auto;
    justify-content: center;
  }
  .print-journey .print-actions > a:not(.lc-action) {
    justify-content: center;
    width: 100%;
  }
  .print-journey .print-delivery-summary {
    grid-template-columns: 24px 1fr;
  }
  .print-journey .print-delivery-summary .lc-action {
    grid-column: 2;
    justify-self: start;
    padding-left: 0;
    margin: 0;
  }
  .print-journey .print-final-facts > div {
    grid-template-columns: 1fr 1.6fr;
  }
}
@media (prefers-reduced-motion: reduce) {
  .print-journey * {
    animation: none !important;
    transition: none !important;
  }
}
@media (forced-colors: active) {
  .print-journey .print-delivery-summary > svg {
    color: CanvasText;
  }
}
